import { createAction, props } from "@ngrx/store";
import { Benefit } from "../../models/benefit";

export const findBenefitCatalogAct = createAction('findBenefitCatalogEffect', props <{ id: number }>());
export const loadBenefitCatalogByIdAct = createAction('loadBenefitCatalogByIdEffect', props<{ benefit: Benefit }>());

export const resetBenefitCatalogAct = createAction('resetBenefitCatalogEffect');

export const updateBenefitCatalogAct = createAction('updateBenefitCatalogEffect', props<{ benefitUpdated: Benefit }>());
export const updateSuccessBenefitCatalogAct = createAction('updateSuccessBenefitCatalogEffect', props<{ benefitUpdated: Benefit }>());

export const saveBenefitCatalogAct = createAction('saveBenefitCatalogEffect', props<{ benefitNew: Benefit }>());
export const saveSuccessBenefitCatalogAct = createAction('saveSuccessBenefitCatalogEffect', props<{ benefitNew: Benefit }>());

export const setViolationsBenefitCatalogAct = createAction('setViolationsBenefitCatalogEffect', props<{ benefitForm: Benefit, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );
